module.exports = __webpack_public_path__ + "e6e64ba7c079f995826fcc9bce74297a.svg";